import type { NextPage, GetServerSidePropsContext } from 'next';
import BusinessPage from '@elem/compPage/Business';
import { ProductProvider } from '@elem/compPage/Business/ProductProvider';
import { IPageStatus } from '@elem/compPage/Business/config/IPageStatus';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { pathname } from '@elem/compPage/Business/config/page';
import { redirectTo404 } from '@/utils';

// 路由跳转白名单
const whiteLocaleList = ['us'];

const Business: NextPage = ({ SEO, timeLine, pageStatus }: any) => {
    const { t } = useLang('business');
    const { locale } = getLocal();

    const initState = {
        timeLine,
        pageStatus,
    };

    return (
        <PageLayout theme="black">
            <SEO
                title={pageStatus === 'statusA' ? t('seo_title') : t('seo_launch_title')}
                description={pageStatus === 'statusA' ? t('seo_desc') : t('seo_launch_desc')}
            />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={pathname} />
            <ProductProvider state={initState}>
                <BusinessPage />
            </ProductProvider>
        </PageLayout>
    );
};

export default Business;

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/Business/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/Business/config/times/us.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    const time = new Date().getTime(); // 服务器时区北京时区

    let currentTime = time;
    let pageStatus = currentTime >= timeLine.statusA.start ? IPageStatus.statusA : '';

    if (debug && !_timer) {
        if (debug === IPageStatus.statusA) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }

    if (_timer) {
        currentTime = new Date(`${_timer} GMT+8`).getTime();
    }

    if (timeLine) {
        if (currentTime >= timeLine.statusA.start) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }

    return {
        props: {
            timeLine: timeLine,
            pageStatus: pageStatus,
        },
    };
}
